module.exports = __webpack_public_path__ + "static/media/coverage.7e47edd9.svg";